import { render, staticRenderFns } from "./AlertHistoryTable.vue?vue&type=template&id=f18a6454"
import script from "./AlertHistoryTable.vue?vue&type=script&lang=js"
export * from "./AlertHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports